import React from 'react';
import { Container } from 'reactstrap';
import AdminHeader from 'components/organisms/adminHeader';
import AdminPanelPatient from 'components/templates/admin/panel/patients';

const AdminPatients = () => (
  <Container>
    <AdminHeader />
    <AdminPanelPatient />
  </Container>
);

export default AdminPatients;
